import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import type { ModuleManifest } from "../api/types";
import { Icon } from "../components/icons";

export function ComingSoon({ moduleId }: { moduleId: string }) {
  const { data } = useQuery({
    queryKey: ["modules"],
    queryFn: () => api<{ modules: ModuleManifest[] }>("/api/modules").then((r) => r.modules),
    staleTime: Infinity,
  });
  const mod = data?.find((m) => m.id === moduleId);
  return (
    <div className="page">
      <div className="empty-state">
        <Icon name={mod?.icon || "module"} size={40} className="muted" />
        <h3>{mod?.label || "Module"} — coming soon</h3>
        <p style={{ maxWidth: 460 }}>{mod?.description}</p>
        <p className="muted" style={{ fontSize: 12.5, maxWidth: 460 }}>
          It's wired into Mockingbird and will share the same project flow as
          proofing. We're building it — check back soon. 🐦
        </p>
      </div>
    </div>
  );
}
